import React, { ReactNode, useReducer } from "react";
import clsx from "clsx";
import { CssBaseline } from "@mui/material";
import { LayoutStyles } from "./styles/Layout.styles";
import { useLocation } from "react-router-dom";

// components
import Header from "./Header";
import Navigation from "./Navigation";
import Footer from "./Footer";
import IntercomComponent from "./Intercom";
import RouteItem from "src/model/RouteItem.model";
import { mainRoutes } from "src/config";
import { TravelRuleStatusBanner } from "src/components/notabene/TravelRuleStatusBanner";
import { DepositActionRequiredBanner } from "src/components/notabene/DepositActionRequiredBanner";
import { AdhocKycBanner } from "src/components/adhocKyc/AdhocKycBanner";
import { useTravelRuleHydrate } from "src/components/notabene/useTravelRuleHydrate";

export interface LayoutProps {
  children: ReactNode;
  routes?: RouteItem[];
  toggleTheme?: () => void;
  useDefaultTheme?: boolean;
}

const Layout = ({ children, routes = mainRoutes, toggleTheme, useDefaultTheme }: LayoutProps) => {
  const classes = LayoutStyles();
  const location = useLocation();
  const [open, toggle] = useReducer((state) => !state, false);
  const [isCoinPage, setIsCoinPage] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (location.pathname.slice(0, 6)) {
      setIsCoinPage((prev) => !prev);
    }
  }, []);

  // Pull any in-flight Notabene transfer from the server on first render so
  // that users on a different device, in private mode, or with localStorage
  // cleared still see the resume banner / can pick up the flow.
  useTravelRuleHydrate();

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Header
        open={open}
        handleMenuOpen={toggle}
        toggleTheme={toggleTheme}
        eye={isCoinPage}
        useDefaultTheme={useDefaultTheme}
      />
      <TravelRuleStatusBanner />
      <DepositActionRequiredBanner />
      <AdhocKycBanner />
      <Navigation routes={routes} open={open} handleMenuClose={toggle} />
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}>
        {children}
      </main>
      <Footer />
      <IntercomComponent />
    </div>
  );
};

export default Layout;
